import {useContext, useRef} from "react"
import {CapabilityContext} from "./CapabilityContext";

/**
 * Custom hook which manages an extra ref variable and keeps it updated with current config.
 *
 * Use-case: To solve stale closures issue in useEffect without re-rendering on context updates.
 * ie. when we don't want to have dependency on capability context in useContext, but need
 * to use updated config inside it, in such cases we use configViewModelRef.
 *
 * @return {{configViewModel, configViewModelRef: React.MutableRefObject<*>, configDispatch}}
 */
const useCapabilityContext = () => {
    const {configViewModel, configDispatch} = useContext(CapabilityContext)
    const configViewModelRef = useRef(configViewModel)
    configViewModelRef.current = configViewModel;
    return {
        configViewModel,
        configDispatch,
        configViewModelRef
    }
}

export default useCapabilityContext


// WEBPACK FOOTER //
// ./src/components/global/context/useCapabilityContext.js